
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { domainStore } from '@/modules/domains';
import { Async } from '@/utils/AsyncDecorators';
import { areaSaggioStore } from '@/modules/AreaSaggio/store/areaSaggio.store';

@Component({})
export default class Row extends Vue {
  @Prop()
  index: number;

  @Prop()
  item: server.areaSaggioPiantaCampione;

  @Prop()
  specieArboree: domains.domini[];

  get specie(): domains.domini
  {
    if (this.item.specie && this.specieArboree && this.specieArboree.length != 0)
      return this.specieArboree.find(f => f.id === this.item.specie);
    return null;
  }
}